import type { ReactNode } from 'react';

interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
  action?: ReactNode;
  className?: string;
}

export default function SectionHeading({ kicker, title, desc, action, className = '' }: SectionHeadingProps) {
  return (
    <div className={`flex flex-col gap-5 md:flex-row md:items-end md:justify-between ${className}`}>
      <div className="max-w-2xl">
        <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-primary-600 md:text-sm">
          <span className="h-px w-6 bg-primary-500" />
          {kicker}
        </div>
        <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">{title}</h2>
        {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}